import { logger } from '../../../../utils/common/logger'
import { Store } from '../../../../utils/storage/keys'
import { ILRApiClientConfig, LoginService } from '../loginradius/services/login-service'
import { IdentityPagesAPI } from './pages-api'

export class VerifyPasswordless {
    public static DOM = {
        class: {
            pageVerifyPasswordless: 'page-verify-passwordless'
        }
    }

    private tokenQueryStringKey = 'vtoken'

    /**
     * Verifies the access token. If token is valid, redirect to the SSO page
     */
    public async init(lrApiConfig?: ILRApiClientConfig) {
        const verifyPasswordlessPage = document.querySelector(`.${VerifyPasswordless.DOM.class.pageVerifyPasswordless}`)
        const urlParams = new URLSearchParams(window.location.search)

        let errors: any = []

        if (verifyPasswordlessPage) {
            if (urlParams.has(this.tokenQueryStringKey)) {
                const token = urlParams.get(this.tokenQueryStringKey)
                const activateButton = urlParams.get(Store.ACTIVATE_BUTTON)

                if (activateButton) {
                    sessionStorage.setItem(Store.ACTIVATE_BUTTON, activateButton)
                }

                try {
                    // check if the token is valid
                    const response = await IdentityPagesAPI.verifyPasswordlessLogin({ vtoken: token })

                    const accessToken = response.access_token
                    if (accessToken && sessionStorage && localStorage) {
                        LoginService.setSessionStorage(urlParams)
                        // store access token in local storage
                        localStorage.setItem(Store.LR_TOKEN_KEY, accessToken)
                        if (!response.jwttoken && lrApiConfig) {
                            // we need jwt token so that analytics dispatched by
                            // the handleLoginSuccess can determine whether the user is a subscriber
                            const lrApiClient = LoginService.getLRApiClient(lrApiConfig, accessToken)
                            response.jwttoken = await lrApiClient.getJwtToken()
                        }
                        await LoginService.handleLoginSuccess(response)
                    } else {
                        logger('error', 'Passwordless email link is invalid')
                        errors = [{Message: 'Passwordless email link is invalid', Id: '-'}]
                    }
                } catch(err) {
                    logger('error', 'Unable to verify passwordless email link', err)
                    errors = [{Message: 'Unable to verify passwordless email link', Id: '-'}]
                }
            } else {
                logger('error', 'Missing vtoken parameter in passwordless email link')
                errors = [{Message: 'Missing vtoken parameter in passwordless email link', Id: '-'}]
            }
            if (errors.length) {
                this.sendErrorsAndRedirect(errors)
            }
        }
    }
    private sendErrorsAndRedirect(errors: any) {
        LoginService.sendSubmissionErrorAnalytics(errors, 'verify-passwordless')
        window.location.replace('/verify-passwordless-error/')
    }
}
